// Ticketing -> BRE-Loyalty PWA read API (docs/contracts/loyalty-wallet-tickets.md).
//
// The loyalty PWA shows a customer's event tickets without copying ticket rows
// into bre-loyalty's database: bre-loyalty-web resolves the customer's sub
// from its own session and calls
//   GET https://api.btowntix.com/api/internal/loyalty/customers/:sub/tickets
//   Authorization: Bearer ${LOYALTY_TICKETS_READ_SECRET}
// Read-only. No QR payloads are returned; view_url deep-links to the Ticketing
// wallet, which renders the credential after its own BRE-Auth session check.
import { z } from 'zod';
import { TicketStatus } from '../enums';
import { BreAuthSub, Id, Timestamp } from '../primitives';

export const LoyaltyWalletTicket = z.object({
  ticket_id: Id,
  order_number: z.string(),
  status: TicketStatus,
  event: z.object({ id: Id, title: z.string(), artwork_url: z.url().nullable() }),
  performance: z.object({
    id: Id,
    starts_at: Timestamp,
    doors_at: Timestamp.nullable(),
    timezone: z.string(),
    venue_name: z.string(),
  }),
  seat: z.object({
    section: z.string().nullable(),
    row: z.string().nullable(),
    seat: z.string().nullable(),
    general_admission_area: z.string().nullable(),
  }),
  ticket_type_name: z.string(),
  view_url: z.url(),
});

export const LoyaltyWalletTicketsResponse = z.object({
  customer_sub: BreAuthSub,
  generated_at: Timestamp,
  upcoming: z.array(LoyaltyWalletTicket),
  past_count: z.int().min(0),
});
export type LoyaltyWalletTicketsResponse = z.infer<typeof LoyaltyWalletTicketsResponse>;
